import React, { useState, useEffect } from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import CancelIcon from "@mui/icons-material/Cancel";
import { useNavigate } from "react-router-dom";
import User from "../../Assets/images/userr.png";
import Button from "../SelectValue/Button";
import SelectBank from "./SelectBank";
import TextBox from "../SelectValue/TextBox";
import postService from "../../Services/post-service";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "white",
  boxShadow: 24,
};

export default function AddBank({ open, handleClose }) {
  const navigate = useNavigate();
  const [bankCode, setBankCode] = useState("");
  const [acc, setAcc] = useState("");
  const [accName, setAccName] = useState("");
  const [loading, setLoading] = useState(false);
  const [bName, setBName] = useState("");
  const [verificationError, setVerificationError] = useState("");

  useEffect(() => {
    if (!open) {
      setBankCode("");
      setAcc("");
      setAccName("");
      setLoading(false);
      setBName("");
      setVerificationError("");
    }
  }, [open]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (acc.length === 10 && bankCode && accName && !verificationError) {
      handleClose(); // Close the modal before navigating
      navigate("/bankcards/pin", {
        state: {
          accountNumber: acc,
          bankCode: bankCode,
          accountName: accName,
          bankName: bName,
        },
      });
    }
  };

  const verifyAccount = async (accountNumber, code) => {
    if (accountNumber.length === 10 && code) {
      setLoading(true);
      setVerificationError("");
      try {
        const res = await postService.validateAccount(accountNumber, code);
        setLoading(false);
        if (res.data && res.data.statusCode === 200) {
          setAccName(res.data.data.accountName);
        } else {
          setAccName("");
          const errorMsg = res.data?.description;
          setVerificationError(errorMsg);
        }
      } catch (error) {
        setLoading(false);
        setAccName("");
        const errorMsg = error.response?.data?.description;
        setVerificationError(errorMsg);
      }
    }
  };

  const handleBankChange = async (code) => {
    setBankCode(code);
    setVerificationError("");
    await verifyAccount(acc, code);
  };

  const handleAccChange = async (value) => {
    setAcc(value);
    setVerificationError("");
    setBankCode("");
    setBName("");
    setAccName("");
  };
  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box sx={style} className=" rounded-lg p-6 pt-10">
            <div className=" h-[70vh] md:mt-5">
              <div className=" mt-6 flex justify-between mb-3">
                <p className=" text-back-color2 text-[18px]  font-[500]">
                  Add Bank
                </p>
                <div>
                  <CancelIcon
                    onClick={handleClose}
                    className=" text-back-color2 cursor-pointer text-[38px]"
                    fontSize="large"
                  />
                </div>
              </div>
              <div>
                <p className=" text-primary-color6 mt-7 mb-3 ">
                  We pay your withdrawals into your bank account. Please make
                  sure the account belongs to you.
                </p>
                <form onSubmit={handleSubmit}>
                  <div>
                    <TextBox
                      label="Account number"
                      type="text"
                      value={acc}
                      onChange={handleAccChange}
                    />
                  </div>

                  <div className=" my-3">
                    {/* <label className=" block mb-2">Select Bank</label> */}
                    <SelectBank
                      bool={true}
                      value={bankCode}
                      onChange={handleBankChange}
                      bName={setBName}
                    />
                  </div>

                  {/* account name  */}
                  <div className="my-5 flex gap-4">
                    <img src={User} alt="user" />
                    <p className=" text-[14px] pt-2 text-[#1E222B] font-[500]">
                      {loading ? "verifying..." : accName}
                    </p>
                  </div>
                  {verificationError && (
                    <div className="bg-[#A844441A] rounded-lg p-2 flex items-center gap-2 my-2">
                      <InfoOutlinedIcon
                        className="text-[#A84444]"
                        sx={{ fontSize: 18 }}
                      />
                      <div>
                        <p className="text-[#A84444] text-[12px] font-bold">
                          {/* {verificationError} */}This account does not match
                          the verified BVN
                        </p>
                      </div>
                    </div>
                  )}
                  <div className=" grid grid-cols-1 mb-5 mt-6">
                    <Button
                      name="Add bank"
                      bool={true}
                      disabled={loading || !!verificationError || !accName}
                    />
                  </div>
                </form>
              </div>
            </div>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}
